<ckeditor [id]="data?.layoutData?.uuid" class="prose" (change)="onChange($event)" id="editor"
    [data]="editorForm.value.content" [editor]="Editor" #editor  [config]="config"></ckeditor>
